import { useGetProductType } from 'src/apis/indexAPI';

export const useIsPsaProduct = () => {
  const { productType } = useGetProductType();

  return productType === 'TimeLogPSA' || productType === 'Trial';
};
